export enum DynamodbMatchType {
  Equals,
  NotEquals,
  LessThan,
  LessThanOrEqualsTo,
  GreaterThan,
  GreaterThanOrEqualsTo,
  BeginsWith,
  In,
  Exists,
  NotExists,
  Condition,
}
